import { memo } from 'react';
import type { ReactNode } from 'react';
import { clsx } from 'clsx';
import styles from './Badge.module.css';

const Badge = ({
    primary = false,
    secondary = false,
    tertiary = false,
    danger = false,
    children,
    small,
    cartIndicator,
    theme,
}: {
    primary?: boolean;
    secondary?: boolean;
    tertiary?: boolean;
    danger?: boolean;
    small?: boolean;
    cartIndicator?: boolean;
    children?: ReactNode;
    theme?: string;
}) => {
    return (
        <div
            className={clsx(styles.badge, theme, {
                [styles.primaryBadge]: primary,
                [styles.secondaryBadge]: secondary,
                [styles.tertiaryBadge]: tertiary,
                [styles.danger]: danger,
                [styles.small]: small,
                [styles.padding]: cartIndicator,
            })}
        >
            {children}
        </div>
    );
};

export default memo(Badge);
